import { Component, EventEmitter, ViewChild, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DRAWER_DATA, DRAWER_REF, DrawerRef } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import { CIPXDrawerContentInterface } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-content.interface';
import { SendMessageComponent } from '../tasksets-list/forms/send-message/send-message.component';
import { OpenQuoteRequestsItem } from '../../dashboard/open-quote-requests-widget/quote-requests.types';
import { CIPXActionBarComponent } from '@sbd-doug-frontend/shared/lib/ui/action-bar/action-bar.component';
import { CIPXPrimaryButtonComponent } from '@sbd-doug-frontend/shared/lib/ui/buttons/primary-button/primary-button.component';
import { CIPXCancelButtonComponent } from '@sbd-doug-frontend/shared/lib/ui/buttons/cancel-button/cancel-button.component';
import { Router, Event, NavigationStart } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Task } from '../tasksets.types';

export interface MessageComposeDrawerData {
  title?: string;
  qr: OpenQuoteRequestsItem;
  task?: Partial<Task>;
}

@Component({
  selector: 'sbd-account-portal-frontend-message-compose-drawer-wrapper',
  standalone: true,
  imports: [CommonModule, SendMessageComponent, CIPXActionBarComponent, CIPXPrimaryButtonComponent, CIPXCancelButtonComponent],
  templateUrl: './message-compose-drawer-wrapper.component.html',
  styleUrl: './message-compose-drawer-wrapper.component.scss',
})
export class MessageComposeDrawerWrapperComponent implements CIPXDrawerContentInterface<MessageComposeDrawerData>, OnInit, OnDestroy {
  @Output() closeRequested: EventEmitter<void>;
  @ViewChild('composer') composer!: SendMessageComponent;

  data = inject(DRAWER_DATA, { optional: true }) as MessageComposeDrawerData | null;
  drawerRef = inject(DRAWER_REF, { optional: true }) as DrawerRef<MessageComposeDrawerWrapperComponent> | null;
  private _router = inject(Router);
  private _unsubscribeAll = new Subject<void>();

  qr: OpenQuoteRequestsItem | null = this.data?.qr ?? null;

  ngOnInit(): void {
    const t = this.data?.title ?? (this.qr?.order_number ? `Send Message · Order ${this.qr.order_number}` : 'Send Message');
    this.drawerRef?.setTitle(t);
    this.drawerRef?.setShowBackButton(true);

    this._router.events
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((event: Event) => {
        if (event instanceof NavigationStart) {
          this.closeDrawer();
        }
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
    this.drawerRef?.close();
  }

  // Called when the drawer back button is clicked
  onBackClick(): void {
    this.closeDrawer();
  }

  closeDrawer(): void {
    this.drawerRef?.close();
  }

  onSend(): void {
    //We don't necessary needs to use signal here or subscription...
    //Instead we can use the composer.sendMessageAction() method directly.
    this.composer?.sendMessageAction();
  }
}
